import React from 'react';
import {
  Box, createStyles, Text, Title, Grid,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

const useStyles = createStyles((theme) => ({
  generalBox: {
    marginBlock: theme.spacing.sm,
  },
}));

interface ExperienceProfessionalSabadellProps {
  [x: string]: any,
}

export default function ExperienceProfessionalSabadell(
  { ...props }: ExperienceProfessionalSabadellProps,
) {
  const { theme } = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'experience.content.professional' });

  const tasksItems = t('content.sabadell-teller.contents.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  return (
    <Box {...props}>
      <Title order={4} align="center" sx={{ padding: 0, marginBottom: theme.spacing.sm }}>
        {t('content.sabadell-teller.contents.title')}
      </Title>
      <Grid justify="space-between" className="border-gradient">
        {tasksItems.map((item) => (
          <Grid.Col xl={2} md={4} xs={6} key={item}>
            <Text size="sm">{item}</Text>
          </Grid.Col>
        ))}
      </Grid>
    </Box>
  );
}
